import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
	root: {
		display: 'block',
		[theme.breakpoints.up('lg')]: {
			display: 'none',
		},
	},
	paper: {
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
	},
	title: {
		fontWeight: 'bold',
		margin: theme.spacing(2),
	},
	closeIcon: {
		position: 'absolute',
		right: 0,
		margin: theme.spacing(1),
		color: 'textSecondary',
	},
	label: {
		textAlign: 'left',
		letterSpacing: '-0.24px',
		fontSize: 12,
		marginLeft: theme.spacing(2),
	},
}));